import { render, staticRenderFns } from "./tickets.vue?vue&type=template&id=b50a9b86&scoped=true&"
import script from "./tickets.vue?vue&type=script&lang=js&"
export * from "./tickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50a9b86",
  null
  
)

export default component.exports